import { useState } from 'react';
import { useAlert } from '@uplift/ui-v2';


export const useDownloadProviderDocument = () => {
  const alert = useAlert();
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadDocument = async (downloadLink: string, filename: string) => {
    setIsDownloading(true);
    try {
      const response = await fetch(downloadLink);

      if (!response.ok) {
        throw new Error(`Download failed with status ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = window.document.createElement('a');

      a.style.display = 'none';
      a.href = url;
      a.download = filename;
      window.document.body.appendChild(a);
      a.click();
      window.document.body.removeChild(a);
      setTimeout(() => window.URL.revokeObjectURL(url), 0);
    } catch {
      alert.error('Failed to download document');
    } finally {
      setIsDownloading(false);
    }
  };

  return { isDownloading, downloadDocument };
};
